import { useSelector } from "react-redux";

import type { TableActionProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import ContactsExportDropdownContainer from "app/pages/sales-intelligence/sub-modules/contacts-search/containers/ExportVariantsDropdown";
import {
    selectNumberOfContactsSearchResults,
    selectSearchResultsAreFetching,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/store/selectors";

import ActivatedExportPanelContainer from "../ActivatedExportPanel/ActivatedExportPanelContainer";

const ExportVariantsDropdownContainer = (props: TableActionProps) => {
    const areSearchResultsFetching = useSelector(selectSearchResultsAreFetching);
    const numberOfResults = useSelector(selectNumberOfContactsSearchResults);

    function handlePanelActivate() {
        props.onActivate(() => ActivatedExportPanelContainer);
    }

    function onClick() {
        companyAnalysisTrackingService.contacts.trackExportContactsDDOpen();
    }

    return (
        <ContactsExportDropdownContainer
            isLoading={areSearchResultsFetching}
            numberOfResults={numberOfResults}
            onActivate={handlePanelActivate}
            onClick={onClick}
        />
    );
};

export default ExportVariantsDropdownContainer;
